import script from "./HrConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HrConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./HrConfirmDialog.vue?vue&type=style&index=0&id=24d847e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d847e8"]])

export default __exports__